import { interaction, isWeb, SizableText, YStack } from '@mythical/ui'
import { BenefitsBanner } from 'app/blocks/landing/benefits-banner'
import { TextLink } from 'app/components/primitive/TextLink'
import { Container } from 'app/components/structure/Container'
import { useStores } from 'app/store'
import { mapColor } from 'app/utils/mapColors'

const BenefitItem = ({
  benefit,
}: {
  benefit: BenefitsBanner['benefits'][number]
}) => {
  const bg = mapColor(benefit.backgroundColour)
  const textColor = mapColor(benefit.foregroundColour)

  return (
    <YStack
      py="$3.5"
      px="$3.5"
      hoverStyle={{ bg: bg }}
      animation="100ms"
      cursor="default"
      $hoverNone={{ bg: bg }}
      {...(!isWeb && { bg: bg })}
    >
      <SizableText
        pos="relative"
        top={isWeb ? '-5%' : '8%'} // Wtf fonts?
        ff="$display"
        col={textColor}
        ta="center"
        tt="uppercase"
        size="$6"
        $gtMd={{ size: '$10' }}
      >
        {benefit.text}
      </SizableText>
    </YStack>
  )
}

const BenefitLinks = ({ benefits, ctaLabel, ctaLink }: BenefitsBanner) => {
  const { userStore } = useStores()
  const canMemberfulLink = userStore?.canMemberfulLink ?? false
  return (
    <Container variant="full">
      {benefits.map((benefit) => (
        <BenefitItem key={benefit.id} benefit={benefit} />
      ))}
      {canMemberfulLink && (
        <TextLink
          ff="$display"
          href={ctaLink}
          py="$3.5"
          px="$3.5"
          ta="center"
          tt="uppercase"
          size="$6"
          $gtMd={{ size: '$10' }}
          {...interaction.opacity}
          hoverStyle={{
            textDecorationLine: 'underline',
            ...interaction.opacity.hoverStyle,
          }}
        >
          {ctaLabel}
        </TextLink>
      )}
    </Container>
  )
}

export default BenefitLinks
